/**
 * Утилита для объединения Tailwind классов: использует clsx для условных классов
 * и tailwind-merge для разрешения конфликтов классов
 */
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Утилита для объединения Tailwind классов
 * Использует clsx для условных классов и tailwind-merge для разрешения конфликтов
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

